import { render, staticRenderFns } from "./PlanoPersonalizado.vue?vue&type=template&id=0af15c08"
import script from "./PlanoPersonalizado.vue?vue&type=script&lang=js"
export * from "./PlanoPersonalizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports